import parseHtmlReact from 'html-react-parser';
import update from 'immutability-helper';

export class OEToolboxCoreClass {

    constructor() {
    }
    
    encode_utf8(s)  {
        // new emscripten version changes string conversation between c++ and js -> no reencoding necessary
        return s; //unescape(encodeURIComponent(s));
    }
    
    decode_utf8(s)  {
        // see encode_utf8
        return s; //decodeURIComponent(escape(s));
    }

    stringToHtml(s)  {
        var mask = '(\n|\r|\r\n|\\\\n)';
        var re = new RegExp(mask,'g');
        var transformed = s.replace(re, '<br/>');

        mask = '(&)';
        re = new RegExp(mask,'g');
        transformed = transformed.replace(re, '&amp;');

        return parseHtmlReact(transformed);
    }

    updateComponentState(component, spec)  {
        component.setState((prevState, props) => { return update(prevState, spec); });
    }

    toInt(str) {
        if(typeof(str) === 'number') return str;
        if(typeof(str) === 'boolean') return str ? 1 : 0;
        if(typeof(str) !== 'string') return;
        let str_ = str.toLowerCase();
        if(str_ === 'true' || str_ === 'false')   return  str_ === 'true' ? 1 : 0;
        let res = Number.parseInt(str);
        return Number.isNaN(res) ? undefined : res;
    }

    toFloat(str) {
        if(typeof(str) === 'number') return str;
        if(typeof(str) === 'boolean') return str ? 1 : 0;
        if(typeof(str) !== 'string') return;
        let str_ = str.toLowerCase();
        if(str_ === 'true' || str_ === 'false')   return  str_ === 'true' ? 1 : 0;
        let res = Number.parseFloat(str);
        return Number.isNaN(res) ? undefined : res;
    }

    toBool(str) {
        if(typeof(str) === 'boolean') return str;
        if(typeof(str) === 'number') return !!str;
        if(typeof(str) !== 'string') return;
        let res = Number.parseFloat(str);
        if(!Number.isNaN(res))  return !!res;
        let str_ = str.toLowerCase();
        return str_ === 'true' ? true : (str_ === 'false' ? false : undefined);
    }

    binaryAdd(input, add)  {
        if(typeof(input) !== 'number' || typeof(add) !== 'number')  return input;
        return input | add;
    }

    binaryRemove(input, remove)  {
        if(typeof(input) !== 'number' || typeof(remove) !== 'number')  return input;
        return input ^ (input & remove);
    }

    binaryAddRemove(input, value, remove)  {
        return remove ? this.binaryRemove(input, value) : this.binaryAdd(input, value);
    }

    getUrlParameter(sParam, defaultValue) {
        let pageURL = decodeURIComponent(window.location.search.substring(1));
        let URLVariables = pageURL.split('&');

        for(var i = 0; i < URLVariables.length; i++) {
            var sParameterName = URLVariables[i].split('=');
            if(sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
        return defaultValue;
    }

    getUrlParameterInt(sParam, defaultValue, min, max) {
        let str = this.getUrlParameter(sParam, defaultValue);
        let res = this.toInt(str);
        
        if(typeof(res) !== 'number')    return defaultValue;
        if(typeof(min) === 'number' && res < min)   return min;
        if(typeof(max) === 'number' && res > max)   return max;
        return res;
    }

    getUrlParameterFloat(sParam, defaultValue) {
        return this.toFloat(this.getUrlParameter(sParam, defaultValue));
    }

    getUrlParameterBool(sParam, defaultValue) {
        return this.toBool(this.getUrlParameter(sParam, defaultValue));
    }

    rectFromDOMRect(domRect)    {
        if(!domRect)    return {x: 0, y: 0, w: 0, h: 0};
        return {x: domRect.left, y: domRect.top, w: domRect.right - domRect.left, h: domRect.bottom - domRect.top}
    }

    jsonEqual(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    shallowEqual(a, b, recursive)  {
        if(typeof(a) !== 'object' || typeof(b) !== 'object' || Array.isArray(a) || Array.isArray(b))    {
            if(Array.isArray(a) && Array.isArray(b))    return a.length === b.length && a.every((e, index) => this.shallowEqual(e, b[index], recursive));
            return a === b;
        }
        
        if(a === b || (!a && !b)) return true;
        if(!a || !b) return false;
        if(Object.keys(a).length != Object.keys(b).length)  return false;

        if(recursive == true)  {
            for(var key in a)   if(!(key in b) || !this.shallowEqual(a[key], b[key], true)) return false;
        } else {
            for(var key in a)   if(!(key in b) || a[key] !== b[key])    return false;
        }

        return true;
    }

    arrayShallowEqual(a, b, recursive) {
        if((a === null && b === null) || (a === undefined && b === undefined)) return true;
        if(!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;

        for(let i = 0; i < a.length; ++i)   {
            if(!this.shallowEqual(a[i], b[i], recursive)) return false;
        }

        return true;
    }

    arrayContentShallowEqual(a, b)    {
        if((a === null && b === null) || (a === undefined && b === undefined)) return true;
        if(!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;

        for(let i = 0; i < a.length; ++i)   {
            let u = a[i];
            if(b.findIndex(v => this.shallowEqual(u, v)) < 0)   return false;
        }

        return true;
    }

    mapShallowEqual(a, b, recursive) {
        if(a === b || (!a && !b)) return true;
        if(!a || !b || a.size !== b.size) return false;

        for(let [key, val] of a) {
            if(!b.has(key)) return false;
            let valB = b.get(key);
            if(!this.shallowEqual(val, valB, recursive))    return false;
        }
        return true;
    }

    numberToString(num, length) {
        var r = num.toString();
        while(r.length < length) {
            r = '0' + r;
        }
        return r;
    }

    localeDecimalSeparator() {
        return (1.1).toLocaleString().substring(1, 2);
    }

    localizeDecimalSeparator(strNumber) {
        if(typeof(strNumber) !== 'string')  return strNumber;
        let locSeparator = this.localeDecimalSeparator();
        return strNumber.replaceAll(',' == locSeparator ? '.' : ',', locSeparator);
    }

    normalizedWheelParams(event)    {
        var ret = {deltaX: event.deltaX, deltaY: event.deltaY, deltaZ: event.deltaZ};

        if(event.deltaMode)   {
            const f = event.deltaMode === 1 ? 33 : 800;
            ret.deltaX *= f; ret.deltaY *= f; ret.deltaZ *= f;
        }

        return ret;
    }

    easeTiming(value)   {
        return 0.5 * (Math.sin(Math.PI*Math.min(Math.max(value, 0), 1) - 0.5 * Math.PI) + 1);
    }

    versionString()  {
        var date = new Date(versioning.date);
        return "Version: " + versioning.version + " - " + versioning.commithash + " - " + date.toLocaleDateString();
    }

    async storageEstimateString(inUsage) {
        if(!navigator.storage || !navigator.storage.estimate)   return '';

        try {
            var estimate = await navigator.storage.estimate();
            var str = `Storage - total: ${(estimate.quota/1e6).toFixed(2)}`;
            if(inUsage) str += ` - in usage: ${(estimate.usage/1e6).toFixed(2)}`;
            return str;
        } catch(e) {
            return '';
        }
    }

    sepFront(str) {
        return str === '' ? str : (', ' + str);
    }

    isFunctionalComponent(comp) {
        return typeof(comp) === 'function' && !(comp.prototype && comp.prototype.isReactComponent);
    }
      
    isClassComponent(comp) {
        return typeof(comp) === 'function' && comp.prototype && comp.prototype.isReactComponent;
    }

    capitalize(str) {
        if(typeof(str) !== 'string' || str.length == 0) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    lowercaseUnderscoreToLowerCamelCase(str)   {
        if(typeof(str) !== 'string' || str.length == 0) return str;
        let capitalizeFirst = str.indexOf('_') === 0;
        let words = str.split('_');
        let ret = '';
        words.forEach((word, i) => {
            ret = ret + (i > 0 || capitalizeFirst ? this.capitalize(word) : word);
        });
        return ret;
    }

    lowerCamelCaseToLowercaseUnderscore(str, separator = '_')   {
        if(typeof(str) !== 'string' || str.length == 0) return str;
        let ret = str;
        let i = 0;
        while(i < ret.length)   {
            let char = ret.charAt(i);
            let isCapital = char !== '-' && char.toUpperCase() == char;
            if(!isCapital)  {
                i++; continue;
            }
            ret = (i > 0 ? ret.substring(0, i) : '') + separator + char.toLowerCase() + (i + 1 < ret.length ? ret.substring(i + 1) : '');
            i = i + 2;
        }
        return ret;
    }

    lowercaseUnderscoreToUpperCamelCase(str)    {
        let ret = this.lowercaseUnderscoreToLowerCamelCase(str);
        return this.capitalize(ret);
    }

    upperCamelCaseToLowercaseUnderscore(str, separator = '_')   {
        if(typeof(str) !== 'string' || str.length == 0) return str;
        let ret = str.charAt(0).toLowerCase() + str.slice(1);
        return this.lowerCamelCaseToLowercaseUnderscore(ret, separator);
    }

    getScrollbarSize_() {
        const outer = document.createElement('div');

        outer.style.width = '100px';
        outer.style.height = '100px';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        document.body.appendChild(outer);

        const inner = document.createElement('div');
        inner.style.width = '100%';
        inner.style.height = '1000px';

        outer.appendChild(inner);

        const scrollbarSize = outer.offsetWidth - inner.offsetWidth + 1;

        outer.parentNode.removeChild(outer);
        return scrollbarSize;
    }

    getScrollbarSize()  {
        // if we have a cached value return it
        if(this.scrollbarSize) return this.scrollbarSize;

        // otherwise initialize cached value and setup a listener to appropriate events to update it
        this.scrollbarSize = this.getScrollbarSize_();

        window.addEventListener('resize', () => {
            this.scrollbarSize = this.getScrollbarSize_();
        });

        return this.scrollbarSize;
    }
    
    stdTMToData(tm) {
        const y = tm.year < 100 ? tm.year : tm.year + 1900;
        return new Date(Date.UTC(y, tm.mon, tm.mday, tm.hour, tm.min, tm.sec));
    }

    iterateChildNodes(node, fn)  {
        node.childNodes.forEach(n => { fn(n); this.iterateChildNodes(n, fn); })
    }

    iterateRelatedNodes(node, fn)    {
        let n = node;
        while(n)    {
            fn(n);
            n = n.parentNode;
        }
        this.iterateChildNodes(node, fn);
    }

    filterObject(obj, allowedKeys, notAllowedKeys) {
        if(typeof(obj) !== 'object')    return obj;
        let ret = Object.keys(obj).filter(key => (!allowedKeys || allowedKeys.includes(key)) && (!notAllowedKeys || !notAllowedKeys.includes(key))).reduce((newObj, key) => { return {...newObj, [key]: obj[key]}; }, {});
        return ret;
    }

    addFilenamePostfix(filename, postfix)   {
        if(!filename || !postfix)   return filename;
        let index = filename.lastIndexOf('.');
        if(index < 0)   return filename;
        return filename.substring(0, index) + postfix + filename.substring(index);
    }

    debounce(func, wait = 100)   {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func(...args); }, wait);
        };
    }

    debounce2(func, wait = 100)   {
        let timer;
        let args_;
        return (...args) => {

            if(!timer)   {
                func(...args);

                timer = setTimeout(() => { 
                    if(args_)    func(...args_);
                    args_ = undefined;
                    timer = undefined;
                }, wait);

                return;
            }

            args_ = args;
        };
    }
};

export default new OEToolboxCoreClass();